(function () {
const __pewniaki_inline_cfg = JSON.parse(document.currentScript.previousElementSibling.textContent);
(function(){
  var root=document.currentScript.closest('[data-ryt-v2]'),button=root&&root.querySelector('[data-ryt-export]'),report=root&&root.querySelector('[data-ryt-report]');
  if(!button||!report)return;
  button.addEventListener('click',function(){
    var blob=new Blob([report.textContent],{type:'application/json;charset=utf-8'}),a=document.createElement('a');
    a.href=URL.createObjectURL(blob);a.download='number-rhythms-' + __pewniaki_inline_cfg[0] + '.json';a.click();
    setTimeout(function(){URL.revokeObjectURL(a.href);},0);
  });
})();
})();
